import {construct, ModelProperties} from '../utils';

export class CtImageType {
    id!: number;

    name!: string;

    placeholder!: boolean;

    sizes!: number[];

    breakpoints!: number[];

    densities!: number[];

    constructor(asset?: ModelProperties<CtImageType>) {
        if (asset) {
            construct(this, asset);
        }
    }
}
